<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label >商品:</label>
            <lk-input v-model="query.goodsCode" class="item" placeholder="请输入商品编码/通用名"></lk-input>
          </div>
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2" >
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label >状态:</label>
            <lk-select v-model='query.status' class="item" clearable>
              <lk-option v-for="item in statusList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button class="mr8" type='primary' @click="toOpenModal('add')" v-if="handlePermission('addPureProfitRate')">添加商品</lk-button>
          <lk-button class="mr8" @click="toOpenModal" v-if="handlePermission('updateBatchPureProfitRate')">批量修改</lk-button>
        </div>
        <lk-table 
          border 
          :columns='columns' 
          :data='tableData'
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"
        />
      </div>
    </QueryFrame>
    <lk-modal
      v-model="isShow"
      title="添加商品"
      :footer-hide="true"
    >
      <div style="margin:0 auto;width:80%;">
        <div class="flex" style="width:100%;margin-left:12px;">
          <label>商品编码：</label>
          <inputSearch
            v-model.trim="addModal.searchContent"
            :columns='searchColumns'
            @getData='toGetDrugData'
            :data='searchData'
            @selected='handleSelect'
            :reset='false'
            :maxlength='35'
            style="width:200px;"
          ></inputSearch>
        </div>
        <div class="flex" style="margin:10px 36px;width:100%;align-items:center;">
          <div>门店：</div>
          <lk-select
            style="width:200px;"
            v-model="addModal.storeIds"
            clearable 
            multiple
            filterable
          >
            <lk-option v-for="item in storeList" :key="item.storeId" :value='item.storeId'>{{item.storeName}}</lk-option>
          </lk-select>
        </div>
        <div class="flex" style="margin:10px 12px;width:100%;align-items:center;">
          <div>是否计提：</div>
          <lk-select
            style="width:200px;"
            v-model="addModal.isProvision"
            clearable 
          >
            <lk-option v-for="item in isProvisionList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div>
          <div class="flex" style="width:100%;">
            期望毛利率：
            <lk-input-number 
              :precision="2" 
              v-model="addModal.profitRate"
              :min="0"
              :max="100"
              placeholder="请输入"
              :active-change="false"
              style="width:170px;"
            ></lk-input-number>
            <div class="percentageIconCon">%</div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:right;margin:20px 20px 0 0;">
        <lk-button type='primary' @click="toConfirm">确定</lk-button>
        <lk-button style="margin-left:16px;" @click="isShow=false">取消</lk-button>
      </div>
    </lk-modal>
    <lk-modal
      v-model="isShowUpdate"
      title="修改"
      :footer-hide="true"
    >
      <div style="margin:0 auto;width:80%;">
        <div class="flex" style="width:100%;margin-left:12px;">
          <label>商品编码：</label>
          <div>{{updateModal.goodsCode || ''}}</div>
        </div>
        <div class="flex" style="margin:10px 36px;width:100%;">
          <label >门店：</label>
          <div>{{updateModal.storeName || ''}}</div>
        </div>
        <div class="flex" style="margin:10px;width:100%;align-items:center;">
          <div>是否计提：</div>
          <lk-select
            style="width:200px;"
            v-model="updateModal.isProvision"
            clearable 
          >
            <lk-option v-for="item in isProvisionList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div>
          <div class="flex" style="width:100%;">
            期望毛利率：
            <lk-input-number 
              :precision="2"
              v-model="updateModal.rate"
              :min="0"
              :max="100"
              placeholder="请输入"
              :active-change="false"
              style="width:200px;"
            ></lk-input-number>
            <div class="percentageIconCon">%</div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:right;margin:20px 20px 0 0;">
        <lk-button type='primary' @click="toConfirmUpdate" :loading="updateLoading">确定</lk-button>
        <lk-button style="margin-left:16px;" @click="isShowUpdate=false">取消</lk-button>
      </div>
    </lk-modal>
    <lk-modal
      v-model="isShowHistory"
      title="查看历史"
      :footer-hide="true"
    >
      <div style="margin:0 auto;width:80%;">
        <div v-for="(item, index) in rateHistoryList">
          <div v-if="index === rateHistoryList.length-1">
            {{`${item.createTime}起由${item.createUserName}设置为${item.rate}%`}}
          </div>
          <div v-else>
            {{`${item.createTime}-${rateHistoryList[index+1] && rateHistoryList[index+1].createTime}由${item.createUserName}设置为${item.rate}%`}}
          </div>
        </div>
      </div>
    </lk-modal>
    <lk-modal
      v-model="isShowBatch"
      title="批量修改"
      :footer-hide="true"
    >
      <div style="margin:0 auto;width:80%;">
        <div>
          <div class="flex" style="width:100%;">
            期望毛利率：
            <lk-input-number 
              :precision="2" 
              v-model="batch.rate"
              :min="0"
              :max="100"
              placeholder="请输入" 
              style="width:170px;"
              :active-change="false"
            ></lk-input-number>
            <div class="percentageIconCon">%</div>
          </div>
        </div>
        <div class="flex" style="margin:10px;width:100%;align-items:center;">
          <div>是否计提：</div>
          <lk-select
            style="width:200px;"
            v-model="batch.isProvision"
            clearable 
          >
            <lk-option v-for="item in isProvisionList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </div>
      </div>
      <div style="display:flex;justify-content:right;margin:20px 20px 0 0;">
        <lk-button type='primary' @click="toConfirmBatchUpdate" :loading="batchUpdateLoading">确定</lk-button>
        <lk-button style="margin-left:16px;" @click="isShowBatch=false">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inputSearch from '../../components/InputSearch.vue';
import DownloadButton from '../../components/download/DownloadButton';
import finance from '../../services/finance.js';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import _ from 'lodash';

export default {
  name: 'pureProfitRateManage',
  components: {
    QueryFrame,
    inputSearch,
    DownloadButton,
  },
  mixins: [mapState, queryMixins],
  computed: {
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item);
      });
      return result;
    }
  },
  data() {
    return {
      batchUpdateLoading: false,
      updateLoading: false,
      isShow: false,
      isShowBatch: false,
      isShowUpdate: false,
      isShowHistory: false,
      tempGoods: [], //存放表格中选中的数据
      rateHistoryList: [],
      query: {},
      searchData: [],
      storeList: [],
      tableData: [{}],
      statusList: [
        {
          id: 1,
          name: '启用'
        },
        {
          id: 2,
          name: '停用'
        },
      ],
      updateValue: 0,
      isProvisionList: [
        {
          id: 1,
          name: '是',
        },
        {
          id: 2,
          name: '否',
        },
      ],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116
        },
        {
          title: '商品编码',
          key: 'serialCode',
          minWidth: 116,
        },
        {
          title: '通用名',
          key: 'approvedName',
          minWidth: 116
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 116
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116
        },
        {
          title: '生产厂家',
          key: 'producer',
          minWidth: 116
        },
        {
          title: '批准文号',
          key: 'approvalNumber',
          minWidth: 116
        },
        {
          title: '单位',
          key: 'minPkgUnitName',
          minWidth: 116
        },
        {
          title: '状态',
          key: 'statusName',
          minWidth: 116
        },
        {
          title: '是否计提',
          key: 'isProvisionName',
          minWidth: 116
        },
        {
          title: '标准毛利率',
          key: 'rateStr',
          minWidth: 116
        },
        {
          title: '操作',
          minWidth: 130,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.handlePermission('updatePureProfitRate') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.isShowUpdate = true;
                  this.updateModal.storeName = params.row.storeName;
                  this.updateModal.goodsCode = params.row.serialCode;
                  this.updateModal.isProvision = params.row.isProvision;
                  this.updateModal.rate = params.row.rate;
                  this.updateModal.storeId = params.row.storeId;
                  this.updateModal.goodsStoreId = params.row.goodsStoreId;
                  this.updateModal.goodsBaseId = params.row.goodsBaseId;
                  this.updateModal.id = params.row.id;
                }
              },
            }, '修改') : '',
            params.row.status === 2 && this.handlePermission('updatePureProfitRateStatus') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否确认启用该商品?</p>',
                    onOk: () => {
                      this.toUpdateGoodsStatus(params.row.id, 1); // 1 启用
                    }
                  })
                }
              }
            }, '启用') : '',
            params.row.status === 1 && this.handlePermission('updatePureProfitRateStatus') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否确认停用该商品?</p>',
                    onOk: () => {
                      this.toUpdateGoodsStatus(params.row.id, 2); // 2 停用
                    }
                  })
                }
              }
            }, '停用') : '',
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.isShowHistory = true;
                  this.rateHistoryList = [];
                  this.toGetHistoryData(params.row.id);
                }
              }
            }, '查看历史'),
          ])
        }
      ],
      currentTitle: 'add',
      searchColumns: [
        {
          title: '商品编码',
          key: 'drugSerialCode',
          width: '60px'
        },
        {
          title: '药品通用名',
          key: 'approvedDrugNames',
          width: '150px',
        },
        {
          title: '商品名',
          key: 'goodsName',
          width: '120px'
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          width: '100px'
        },
        {
          title: '规格',
          key: 'specifications',
          width: '60px'
        },
        {
          title: '包装单位',
          key: 'drugMiniPackageUnitString',
          width: '50px'
        },
      ],
      addModal: {
        searchContent: '',
        storeIds: [],
        profitRate: 0,
        isProvision: '',
      },
      updateModal: {
        storeName: '',
        goodsCode: '',
        isProvision: '',
        rate: 0,
      },
      batch: {
        rate: 0,
        isProvision: '',
      },
      selectedGood: {
        id: null,
      }
    }
  },
  methods: {
    toConfirm() {
      if (!this.addModal.isProvision) {
        this.$Message.error('请先选择是否计提');
        return
      }
      let list = [];
      this.addModal.storeIds.forEach(item => {
        let obj = this.storeList.find(listItem => listItem.storeId === item);
        list.push(obj);
      })
      const param = {
        goodsBaseId: this.selectedGood.id,
        rate: this.addModal.profitRate,
        profitRateGoodsVoList: list,
        isProvision: this.addModal.isProvision,
      }
      finance.toAddProfitRate(param).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('添加成功');
          this.isShow = false;
          this.addModal = {
            searchContent: '',
            storeIds: [],
            profitRate: 0,
            isProvision: '',
          },
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toOpenModal(type) {
      if (type === 'add') {
        this.isShow = true;
      } else {
        this.isShowBatch = true;
      }
    },
    clear() {
      this.query = {};
    },
    toGetDrugData() {
      const params = {
        nameMix: this.addModal.searchContent,
        page: 1, // 根据后端要求暂时写死值
        size: 100, // 同上
      }
      finance.toSearchGoods(params).then(res => {
        if (res.data.status === 200) {
          const list = res.data.data.list.map(item => {
            return item = Object.assign({}, item, item.goodsBase);
          })
          this.searchData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleSelect(val) {
      this.selectedGood.id = val.id;
      this.addModal.searchContent = val.drugSerialCode;
      this.toSearchStores(val.id);
    },
    toConfirmUpdate: _.debounce(function(){
      if (!this.updateModal.isProvision) {
        this.$Message.error('请先选择是否计提');
        return
      }
      const params = this.updateModal;
      this.updateLoading = true;
      finance.toUpdateSinglePR(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('修改成功');
          this.isShowUpdate = false;
          setTimeout(()=> {
            this.updateLoading = false;
          }, 1000)
          this.getData();
        } else {
          this.$Message.error(res.data.error);
          this.updateLoading = false;
        }
      }).catch(err => {
        this.updateLoading = false;
        utils.handleError(err);
      });
    }, 1000),
    toSearchStores(id) {
      this.storeList = [];
      const params = {
        goodsBaseId: id
      };
      finance.toSearchStores(params).then(res => {
        if (res.data.status === 200) {
          this.storeList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error);
        } 
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toUpdateGoodsStatus(id, type) { // 启用停用商品毛利率
      const params = {
        id,
        type
      }
      finance.toUpdateProfitStatus(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success(`${type === 1 ? '启用' : '停用'}成功`);
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetHistoryData(id) {
      finance.toGetHistoryPR({id}).then(res => {
        if (res.data.status === 200) {
          res.data.data.forEach(item => {
            item.createTime = utils.formatDate(item.createTime);
          })
          this.rateHistoryList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error)
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toConfirmBatchUpdate: _.debounce(function() {
      if (!this.batch.isProvision) {
        this.$Message.error('请先选择是否计提');
        return
      }
      const param = {
        profitRateIdList: this.tempGoods,
        rate: this.batch.rate,
        isProvision: this.batch.isProvision,
      };
      this.batchUpdateLoading = true;
      finance.toUpdateBatchPR(param).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('批量修改成功');
          this.batch = {
            rate: 0,
            isProvision: '',
          },
          this.isShowBatch = false;
          setTimeout(()=> {
            this.batchUpdateLoading = false;
          }, 1000)
          this.tempGoods = [];
          this.getData();
        } else {
          this.$Message.error(res.data.error);
          this.batchUpdateLoading = false;
        }
      }).catch(err => {
        this.batchUpdateLoading = false;
        utils.handleError(err);
      });
    }, 1000),
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row.id);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.id)) {
          this.tempGoods.push(item.id);
        }
      });
    },
    handleSelectAllCancel() {
      this.tempGoods = [];
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      finance.getProfitRateList(this.params).then(res => {
        if (res.data.status === 200) {
          let list = res.data.data.list || [];
          list.forEach(item => {
            item._checked = this.selectedTempGoodsIds.includes(item.id);
            item.statusName = item.status === 1 ? '启用' : '停用';
            item.isProvisionName = item.isProvision === 1 ? '是' : '否';
            item.rateStr = `${item.rate}%`;
          })
          this.tableData = list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
  },
  mounted() {
    this.handleSearch(true);
  }
}
</script>
<style lang='less' scoped>
.btns {
  margin-bottom: 12px
}
.flex {
  display: flex;
  align-items: center;
}
.percentageIconCon {
  width: 30px;
  height: 32px;
  text-align: center;
  line-height: 30px;
  background-color: gainsboro;
}
</style>
